/**
 * Allergies Service
 * Patient allergy tracking and management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AllergyTypeResponseDto { 
    /**
     * Allergy type identifier
     */
    id: string;
    /**
     * Collection identifier
     */
    collectionId: string;
    /**
     * Unique slug for the allergy type
     */
    slug: string;
    /**
     * Display name of the allergy type
     */
    display: string;
    /**
     * Description of the allergy type
     */
    description?: string;
    /**
     * Status of the allergy type
     */
    status: AllergyTypeResponseDto.StatusEnum;
    /**
     * Metadata schema for the allergy type
     */
    metadataSchema?: any;
    /**
     * Record schema for the allergy type
     */
    recordSchema?: any;
    /**
     * Form identifier associated with the allergy type
     */
    formId?: string;
}
export namespace AllergyTypeResponseDto {
    export type StatusEnum = 'draft' | 'active' | 'inactive';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


